"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (keyLength) {
  return Math.random().toString(36).substr(2, keyLength);
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web-router@0.2.0-alpha.1@@bone/web-router/lib/history/createKey.js
// module id = 562
// module chunks = 4